import { rawApi } from '../../api/client';
import { detailKey } from '../../api/queryKeys';

export const ORDERS_PATH = '/admin/v1/suppliers/purchase-orders';

/** A line of an order, with how much of it has actually turned up. */
export interface OrderLine {
  id: string;
  inventoryItemId: string;
  qty: number;
  unit: string;
  unitPriceMinor: number;
  currency: string;
  receivedQty: number;
}

export interface OrderDetail {
  po: {
    id: string;
    supplierId: string;
    status: string;
    orderedAt?: string | null;
    note?: string | null;
  };
  supplierName: string | null;
  lines: OrderLine[];
  totalMinor: number;
  receipts: { id: string; receivedAt: string; invoiceNumber: string | null; status: string }[];
}

/**
 * One order and everything on it.
 *
 * Shared so the screen that shows an order and the form that receives it read the same cache
 * entry: recording the delivery updates what has arrived, and two copies of that under two keys
 * is how a manager comes to see "nothing arrived" on the order he has just received.
 */
export function orderQuery(orderId: string) {
  return {
    queryKey: detailKey(ORDERS_PATH, orderId),
    queryFn: () => rawApi<OrderDetail>('GET', `${ORDERS_PATH}/${orderId}`),
    enabled: Boolean(orderId),
  };
}

/**
 * How much of a line has not arrived. Compared with a thousandth of slack because quantities are
 * stored as decimals: ten kilos received against ten ordered can differ in the last binary place,
 * and an order a fraction of a gram short would sit open for ever.
 */
export function outstandingQty(line: OrderLine): number {
  return Math.max(0, Math.round((line.qty - line.receivedQty) * 1000) / 1000);
}
